import {globalAttributeIdKeyBuilderFromCondition} from './globalAttributeIdKeyBuilderFromCondition';

export function indexConditions(conditionalVariantValues) {
	const index = {};

	// console.log('Indexing conditional variant values...', conditionalVariantValues);

	conditionalVariantValues.forEach((ccvs) => {
		const conditions = [...ccvs.Conditions]
			.map((condition) => ({
						key: globalAttributeIdKeyBuilderFromCondition(condition.AttributeReference.GlobalAttributeId),
						value: condition.ValueId
					})
			);
		ccvs.ConditionalVariantValues.forEach((ccv) => {

			// WORKAROUND: Remove 'RETURN_' from id
			const id = ccv.Id.replace('REDTAB.RETURN_', '').replace('RETURN_', '');

			const key = ccv.Type + '.' + id + '.' + (ccv.Side !== '' ? ccv.Side : '1');
			const item = {
				conditions: conditions,
				value: ccv.Value
			};

			// WORKAROUND: Replace wrong attributeIds with the real ones
			/*
			item.conditions = item.conditions.map( (condition) => {
				let updatedCondition = condition;
				attributeIdReplacements.forEach(replacement => {
					updatedCondition = updatedCondition.replace(replacement.search, replacement.replace);
				});
				return updatedCondition;
			});
			*/

			if (key in index) {
				// existing condition
				index[key].push(item);
			} else {
				// new condition
				index[key] = [item];
			}
		});
	});
	// console.log('conditional variant value index', index);
	return index;
}
